/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useCallback } from 'react'
import { Helmet } from 'react-helmet'
import { useLocation, useNavigate } from 'react-router-dom'
import Lottie from 'lottie-react'
import locationAnimation from '../../../_metronic/assets/animations/location.json'
import { getUserPosition } from 'app/utils/geolocation'
import { setStoredUserLocation } from 'app/utils/userLocation'
import UnitUnavailableModal from 'app/utils/UnitUnavailableModal'

const RequestLocationPage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [requesting, setRequesting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [showUnitUnavailableModal, setShowUnitUnavailableModal] = useState(
    Boolean((location.state as { unitUnavailable?: boolean } | null)?.unitUnavailable)
  )

  const handlePermissionGranted = useCallback(
    (latitude: number, longitude: number) => {
      setStoredUserLocation(latitude, longitude)
      navigate('/', { state: { latitude, longitude } })
    },
    [navigate]
  )

  const handlePermitir = () => {
    setError(null)

    if ((window as any).ReactNativeWebView) {
      setRequesting(true)
      ;(window as any).ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'request-location-permission' })
      )
      return
    }

    setRequesting(true)
    getUserPosition()
      .then((position) => {
        handlePermissionGranted(
          position.coords.latitude,
          position.coords.longitude
        )
      })
      .catch(() => {
        setRequesting(false)
        setError(
          'Não foi possível obter sua localização. Verifique se os serviços de localização estão ativados no sistema e tente novamente.'
        )
      })
  }

  useEffect(() => {
    const handler = (e: MessageEvent) => {
      try {
        const msg =
          typeof e.data === 'string' ? JSON.parse(e.data) : e.data
        if (msg?.type === 'location-permission-result') {
          setRequesting(false)
          if (msg.data?.granted && msg.data.latitude != null) {
            handlePermissionGranted(msg.data.latitude, msg.data.longitude)
          }
        }
      } catch {}
    }
    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [handlePermissionGranted])

  return (
    <>
      <UnitUnavailableModal
        show={showUnitUnavailableModal}
        onClose={() => setShowUnitUnavailableModal(false)}
      />

      <Helmet>
        <title>Localização - Atacante App</title>
      </Helmet>

      <div className="card mb-5 mb-xl-10">
        <div className="card-body pt-9 pb-9 text-center">
          <div className="mb-10">
            <h1 className="mb-3">Onde você está?</h1>
            <p className="text-muted fs-6 mb-0">
              Precisamos da sua localização para encontrar partidas perto de
              você!
            </p>
          </div>

          <div
            className="d-flex justify-content-center mb-10"
            style={{ minHeight: 300 }}
          >
            <Lottie
              animationData={locationAnimation}
              loop
              style={{ width: 300, height: 300 }}
            />
          </div>

          <p className="text-muted fs-7 mb-4">
            Você pode alterar posteriormente nas configurações do aplicativo
          </p>

          {error && (
            <p className="text-danger fs-7 mb-4">{error}</p>
          )}

          <button
            type="button"
            className="btn btn-primary btn-lg"
            onClick={handlePermitir}
            disabled={requesting}
          >
            {requesting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Aguarde...
              </>
            ) : (
              'Permitir'
            )}
          </button>
        </div>
      </div>
    </>
  )
}

export { RequestLocationPage }
